import '@/class-component-hooks.ts'
import axios from 'axios'
import Vue from 'vue'
import VConfirmDialog from 'vuetify-confirm'
import JsonViewer from 'vue-json-viewer'
import '@/plugins/vuetify'
import '@/theme.scss' 
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
//import builddata from '@/api/mocks/datas' //impot mock data
//add filter
import '@/filter/formatDate'
import '@/filter/formatEPSG4326ToHDMS'
import '@/filter/formatEPSG4326ToGlider'
import '@/filter/formatEPSG4326'
import '@/filter/formatRadToDeg'
import '@/filter/formatDuree'
import '@/filter/formatDistance'
import '@/filter/formatArea'
import '@/filter/formatBearing'
import '@/filter/formatBytes'
import App from '@/App.vue'
import createRouter from '@/router'
import Vuebar from 'vuebar'
import VueLayers from 'vuelayers'
import store from '@/store'
import * as VueWindow from '@hscmap/vue-window'
import AutoVirtualScrollList from '@/components/shared/vue-auto-virtual-scroll-list'  
import { VueResponsiveComponents  } from "vue-responsive-components"
import VueNativeSock from 'vue-native-websocket'
import VueDragDrop from 'vue-drag-drop'
import FlagIcon from 'vue-flag-icon'
import VirtualTable from '@/components/shared/VirtualTable'
import StoreHelper from '@/plugins/storeHelper'
import '@/api/mocks' 
import {i18n} from'./locale/vueI18n'
import types from '@/store/all-mutation-types'
import { DataPoolGlobalKeys } from '@/enum/DataPool'
import TextHighlight from 'vue-text-highlight'
import LatLngField  from '@/components/shared/field/LatLngField.vue'
import NumberFieldFactor from '@/components/shared/field/NumberFieldFactor.vue'
import VueVirtualScroller from 'vue-virtual-scroller'


const configElement = document.getElementById( 'config' );
const config = JSON.parse( configElement.innerHTML );
let removeAuthorization = false

//On regarde si on est dans le cas d'un authorisation auto avec FULLTRUST_ALLOWED
const urlParams = new URLSearchParams(window.location.search);
if(urlParams.get("FULLTRUST_ALLOWED") == "1") {  
  removeAuthorization = true
  //on met une fausse valeur afin de simuler un user authentifié
  localStorage.setItem('user-token','FULLTRUST_ALLOWED')  
}

const memoToken = localStorage.getItem('user-token') || '' 
if(memoToken.length > 0 && !removeAuthorization) axios.defaults.headers.common['authorization'] = memoToken

//on est dans le cas d'un FULLTRUST_ALLOWED on vire le header pour que le renewToken passe grace au fullTrust
if(removeAuthorization) delete axios.defaults.headers.common['authorization']


/*builddata().then(() => {*/
  Vue.config.productionTip = false
  Vue.use(VConfirmDialog,{width:400})
  Vue.use(VueResponsiveComponents)
  Vue.use(Vuebar)
  Vue.use(VueLayers)
  Vue.use(VueWindow)
  Vue.use(VueDragDrop)
  Vue.use(FlagIcon)
  Vue.use(StoreHelper)
  Vue.use(JsonViewer)
  Vue.component('auto-virtual-scroll-list', AutoVirtualScrollList)  
  Vue.component('virtual-table', VirtualTable)  
  Vue.component('text-highlight', TextHighlight)
  Vue.component('lat-lng-field', LatLngField)
  Vue.component('number-field-factor', NumberFieldFactor)
  Vue.use(VueVirtualScroller)
  
  
  if(urlParams.get("disableWs") != "1"){
  /*if(config.wsURL && config.wsURL.length > 0)  
  {
    const protocol = document.location.protocol    
    if(protocol == 'https:') config.wsURL = config.wsURL.replace("ws:","wss:")*/
      Vue.use(VueNativeSock,     
        'ws://localhost' ,{
        connectManually:true,          
        reconnection: true,
        reconnectionAttempts: 1000,
        reconnectionDelay: 3000, 
        store,    
        passToStoreHandler: function (eventName, event) {
          if (!eventName.startsWith('SOCKET_')) { return }
          let target = eventName.toUpperCase()
          let method = target =='SOCKET_ONMESSAGE'?'dispatch':'commit'      
          let msg = event
          if (this.format === 'json' && event.data) {
            msg = JSON.parse(event.data)
            if (msg.mutation) {
              target = [msg.namespace || '', msg.mutation].filter((e) => !!e).join('/')
            } else if (msg.action) {
              method = 'dispatch'
              target = [msg.namespace || '', msg.action].filter((e) => !!e).join('/')
            }
          }
          this.store[method](target, msg)
        }    
      })  
   // }
  }

  export const router = createRouter(store)  

  //TODO LOGIQUE DE RECHARGEMENT DE STATE ICI
  
  store.dispatch(types.DATAPOOL_MSG_ACCUEIL_REQUEST).finally(()=>{  
    if(removeAuthorization)
    {
      store.dispatch(types.AUTH_USER_REQUEST).then(()=>{
        new Vue({
          i18n,
          router,
          store,
          render: h => h(App)
        }).$mount('#app')
      })
    }
    else{      
      if (store.getters.isAuthenticated) {                         
        store.dispatch(types.AUTH_USER_REQUEST).finally(()=>{          
          new Vue({
            i18n,
            router,
            store,
            render: h => h(App)
          }).$mount('#app')  
        })
      }
      else {
        new Vue({
          i18n,
          router,
          store,
          render: h => h(App)
        }).$mount('#app')
      }  
  }
  })

  window.store = store
//}) 
